module.exports = __webpack_public_path__ + "img/3-1@2x.66ddacac.png";